import { apiRequest } from "./apiClient";

const unwrapData = (response) => response?.data ?? response ?? [];

export const fetchPharmacistRecommendations = async (search = "") => {
  const params = new URLSearchParams();

  if (search.trim()) {
    params.set("search", search.trim());
  }

  const response = await apiRequest(
    `/pharmacist-recommendations${params.toString() ? `?${params}` : ""}`,
  );

  return unwrapData(response);
};

export const createPharmacistRecommendation = async (payload) => {
  const response = await apiRequest("/pharmacist-recommendations", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return unwrapData(response);
};

export const updatePharmacistRecommendation = async (id, payload) => {
  const response = await apiRequest(`/pharmacist-recommendations/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return unwrapData(response);
};

export const deletePharmacistRecommendation = async (id) => {
  return apiRequest(`/pharmacist-recommendations/${id}`, {
    method: "DELETE",
  });
};
